import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Lifestyle Image (hidden on mobile) */}
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img
          src="/assets/login.lifestyle.png"
          alt="Artwork in modern interior"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Right side - Auth forms */}
      <div className="flex-1 flex flex-col justify-center items-center p-8 bg-background">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center lg:hidden">
            <h2 className="font-serif text-3xl font-semibold tracking-tight">Arthaus</h2>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

